<template>
  <div>
    <md-card>
      <md-card-content class="md-layout">
        <p class="md-layout-item md-size-100 pb-4 p-0">
          {{ $t("extended_exportation.report_options") }}
        </p>
        <div class="md-layout-item md-size-30 pl-0">
          <md-field>
            <label>{{ $t("class.term") }}</label>
            <md-select v-model="termSelected">
              <md-option
                v-for="option in termList"
                :value="option.id"
                :key="option.id + option.name"
                >{{ option.name }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <p class="md-layout-item md-size-100 pl-0">
          {{ $t("extended_exportation.exported_report") }}
        </p>
        <div class="md-layout-item md-size-30 pl-0 pt-2">
          <checkbox-multi-select
            label="common.grade"
            :options="gradeList"
            v-model="gradeSelected"
            trackBy="name"
            :showSelectAll="true"
          ></checkbox-multi-select>
        </div>
        <div class="md-layout-item md-size-30 pl-8 pt-5">
          <md-checkbox v-model="activeSelected" value="active">
            {{ $t("extended_exportation.active_only") }}
          </md-checkbox>
        </div>
      </md-card-content>
    </md-card>
    <div class="flex justify-center pt-2">
      <md-button class="md-warning md-round" @click="exportPDF()"
        >{{ $t("communication.send_email") }}
      </md-button>
    </div>
  </div>
</template>

<script>
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import { Message } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";

export default {
  components: { CheckboxMultiSelect },
  data() {
    return {
      termSelected: "",
      termList: [],
      gradeList: [],
      gradeSelected: [],
      activeSelected: null
    };
  },
  created() {
    this.fetchTermOpts();
    this.fetchGradeOpts();
  },
  methods: {
    fetchTermOpts() {
      this.$axios
        .get(service_paths.terms, { order_by: "created_at DESC", limit: 100 })
        .then(response => {
          this.termList = response.data.data.map(term => ({
            id: term.id,
            name: term.name
          }));
          this.termSelected = this.termList[0].id;
        });
    },
    fetchGradeOpts() {
      this.$axios
        .get(`${service_paths.grades}`, { limit: 20 })
        .then(response => {
          this.gradeList = response.data.data.map(grade => {
            this.gradeSelected.push(grade.name);
            return {
              id: grade.id,
              name: grade.name
            };
          });
        });
    },
    exportPDF() {
      let params = {
        term: this.termSelected,
        grades: this.gradeSelected,
        active: this.activeSelected
      };
      this.$axios
        .get(`${service_paths.export}/card-batch/pdf`, params)
        .then(response => {
          if (response.status === 200) {
            Message.success(
              this.$t("extended_exportation.export_file_successfully")
            );
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .checkbox-multi-selections label {
  display: block;
  margin: -3px 0;
  color: #aaa;
  font-weight: 400;
}
</style>
